import React from 'react'
import cn from 'classnames'
import { isMobile, l, Radio, RadioGroup } from '@manychat/manyui'

import { ReasonListLabels } from 'common/billing/constants/reasonListLabels'
import { CancellationReasonType } from 'common/billing/interfaces/cancellationReasons'
import { CancellationReason } from 'shared/api/requests/billing/schemas'

interface ICancelReason {
  value?: CancellationReasonType | null
  options: Array<{
    id: CancellationReason['id']
    value: CancellationReason['id']
    label: CancellationReason['label']
  }>
  onChange: (value: string) => void
  reasons: CancellationReason[]
}

const CancelReason = ({ value, options, onChange, reasons }: ICancelReason) => {
  const currentReasonId = options[0].id
  const nestedReasons = reasons.filter((r) => r.parent === currentReasonId)

  const activeNestedReason = nestedReasons?.find((val) => val.id === value)
  const currentValue = activeNestedReason?.parent || value

  return (
    <>
      <RadioGroup name="cancel-options" value={currentValue} onChange={onChange}>
        {options.map((option) => {
          return (
            <Radio
              key={option.id}
              name="cancel-options"
              className={cn({ 'm-b-xs': isMobile })}
              id={option.id}
              value={option.value}
              label={option.label}
            />
          )
        })}
      </RadioGroup>
      {nestedReasons?.length > 0 && currentValue === currentReasonId && (
        <div className="p-l-md">
          {nestedReasons
            .map((reason) => ({
              id: reason.id,
              value: reason.id,
              label:
                reason.id in ReasonListLabels
                  ? l.getString(ReasonListLabels[reason.id])
                  : reason.label,
            }))
            .map((reason) => {
              return (
                <RadioGroup name="nested-reasons" value={value} onChange={onChange} key={reason.id}>
                  {[reason].map((option) => {
                    return (
                      <Radio
                        key={option.id}
                        className={cn({ 'm-b-xs': isMobile })}
                        name="nested-reasons"
                        id={option.id}
                        value={option.value}
                        label={option.label}
                      />
                    )
                  })}
                </RadioGroup>
              )
            })}
        </div>
      )}
    </>
  )
}

export default CancelReason
